import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-account-modal-body',
  templateUrl: './access-account-modal-body.component.html',
  styleUrls: ['./access-account-modal-body.component.scss']
})
export class AccessAccountModalBodyComponent implements OnInit {

  @Output() closeModal = new EventEmitter<void>();
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  redirectToLogin(): void {
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: this.router.url
      }
    });
  }

}
